import { render } from "./Escort.vue?vue&type=template&id=72f017d5"
import script from "./Escort.vue?vue&type=script&lang=js"
export * from "./Escort.vue?vue&type=script&lang=js"

import "./Escort.vue?vue&type=style&index=0&id=72f017d5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__